import React, { useState } from 'react';

// Temporary placeholder components (can be replaced with actual modals)
const TermsOfService = ({ isOpen, onClose }) => null;
const PrivacyPolicy = ({ isOpen, onClose }) => null;
const RefundPolicy = ({ isOpen, onClose }) => null;

const Footer = () => {
  // State for modals
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const [isRefundOpen, setIsRefundOpen] = useState(false);

  return (
    <footer className="w-full bg-white text-center py-3 text-gray-600 border-t">
      <div>
        <div>
          <p className="text-xs text-gray-500 mt-1 px-4 max-w-4xl mx-auto">
            Purpose & scope. <strong>
              <span className="text-blue-700">Nest</span>
              <span className="text-green-600">Quest</span>
              <span className="text-blue-700">ROI</span>
            </strong> is a mathematical simulation engine and research framework offered for educational, research, and comparative analysis. Outputs are reproducible from the simulator using explicit parameter blocks and ruleset hashes.
          </p>

          <p className="text-xs text-gray-500 mt-1 px-4 max-w-4xl mx-auto">
            No advice; no fiduciary duty. Nothing on this site (or in the simulator or book) is financial, legal, tax, or regulatory advice. Any use of concepts or outputs is at your own risk. Validate assumptions locally and consult qualified professionals. Unless you engage <strong>
              <span className="text-green-600">Soft</span>
              <span className="text-blue-600">Tel</span>
              <span className="text-green-600">R</span>
              <span className="text-blue-600">G</span>
            </strong> under a signed advisory agreement, no fiduciary duty is created.
          </p>

          <p className="text-xs text-gray-500 mt-1 px-4 max-w-4xl mx-auto">
            Reproducibility & peer review. Methods and parameter blocks are published for independent reruns. Results are intended to be auditable and reproducible. Formal peer review is welcome.
          </p>

          <p className="text-xs text-gray-500 mt-1 px-4 max-w-4xl mx-auto">
            Intellectual property. © {new Date().getFullYear()}{" "} <strong>
              <span className="text-green-600">Soft</span>
              <span className="text-blue-600">Tel</span>
              <span className="text-green-600">R</span>
              <span className="text-blue-600">G</span>
            </strong>. All rights reserved. All site content—text, models, figures, data structures, and the unique organization of the <strong>
              <span className="text-blue-700">Nest</span>
              <span className="text-green-600">Quest</span>
              <span className="text-blue-700">ROI</span>
            </strong> system—is protected by copyright. <strong>
              <span className="text-blue-700">Nest</span>
              <span className="text-green-600">Quest</span>
              <span className="text-blue-700">ROI</span>
            </strong>™ and related names and trade dress are claimed as <strong>
              <span className="text-green-600">Soft</span>
              <span className="text-blue-600">Tel</span>
              <span className="text-green-600">R</span>
              <span className="text-blue-600">G</span>
            </strong> marks.

            No warranty; limitation of liability. Services and materials are provided “as is,” without warranties of any kind. To the fullest extent permitted by law, <strong>
              <span className="text-green-600">Soft</span>
              <span className="text-blue-600">Tel</span>
              <span className="text-green-600">R</span>
              <span className="text-blue-600">G</span>
            </strong> disclaims implied warranties and will not be liable for any indirect, incidental, special, consequential, or exemplary damages arising from use of the site, simulator, or book.
            </p>

<p className="text-xs text-gray-500 mt-1 px-4 max-w-4xl mx-auto">
            Attribution. Founder: Mohammed Billah. 
          </p>

          <p className="mt-2">
            © {new Date().getFullYear()}{" "}
            <strong>
              <span className="text-green-600">Soft</span>
              <span className="text-blue-600">Tel</span>
              <span className="text-green-600">R</span>
              <span className="text-blue-600">G</span>
            </strong>{" "}
            All rights reserved.
          </p>
          {/* <p>
            <strong>
              <span className="text-blue-700">Nest</span>
              <span className="text-green-600">Quest</span>
              <span className="text-blue-700">ROI</span>
            </strong>{" "}
            is a mathematical simulation tool developed and managed by{" "}
            <strong>
              <span className="text-green-600">Soft</span>
              <span className="text-blue-600">Tel</span>
              <span className="text-green-600">R</span>
              <span className="text-blue-600">G</span>
            </strong>.
          </p>

          <p className="text-sm text-gray-500 mt-1 px-4 max-w-4xl mx-auto">
          Academic use only. This site, the simulator, and the book are provided for educational and research purposes. Results are auditable and reproducible. Peer review is welcome. They are not financial, legal, tax, or regulatory advice. You alone are responsible for any decisions you make. Consult a qualified professional—or engage a formal advisory agreement—before taking action.
          </p>
          <p className="mt-2">
            © {new Date().getFullYear()}{" "}
            <strong>
              <span className="text-green-600">Soft</span>
              <span className="text-blue-600">Tel</span>
              <span className="text-green-600">R</span>
              <span className="text-blue-600">G</span>
            </strong>{" "}
            All rights reserved.
          </p> */}
        </div>

        {/* <div className="space-x-4 mt-2">
          <button
            onClick={() => setIsTermsOpen(true)}
            className="text-black underline hover:bg-gray-200 transition bg-transparent border-none px-2 py-1 rounded"
          >
            Terms of Service
          </button>

          <button
            onClick={() => setIsPrivacyOpen(true)}
            className="text-black underline hover:bg-gray-200 transition bg-transparent border-none px-2 py-1 rounded"
          >
            Privacy Policy
          </button>

          <button
            onClick={() => setIsRefundOpen(true)}
            className="text-black underline hover:bg-gray-200 transition bg-transparent border-none px-2 py-1 rounded"
          >
            Refund Policy
          </button>

          <button
            onClick={() =>
              window.open("https://billing.stripe.com/p/login/eVa17Ff248zAcj64gg", "_blank")
            }
            className="text-black underline hover:bg-gray-200 transition bg-transparent border-none px-2 py-1 rounded"
          >
            Subscription
          </button>
        </div> */}

        {/* Modal placeholders (non-rendering for now) */}
        <TermsOfService isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} />
        <PrivacyPolicy isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} />
        <RefundPolicy isOpen={isRefundOpen} onClose={() => setIsRefundOpen(false)} />
      </div>
    </footer>
  );
};

export default Footer;
